import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useBattlefield = () => {
  const [battlefield, setBattlefield] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/battlefield/all')
        .then((response) => {
          setBattlefield(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [battlefield]
}

export default useBattlefield
